import { useEffect, useState } from "react";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import MedicalHistoryService from "../../../../Services/MedicalHistoryService";



export default function Medication({ patientId }) {
  const [medication, setMedication] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState("All");

  const fetchPatientMedication = () => {
    setLoading(true);
    const payload = {
      patientCode: patientId,
      status: 1,
    };
    MedicalHistoryService.PatientMedication(payload)
      .then((result) => {
        setMedication(result?.data || []);
      })
      .catch((e) => {
        console.error("Failed to fetch medication:", e);
        setMedication([]);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchPatientMedication();
  }, [patientId]);

  const filteredData = selectedTab === "All" ? medication : [];

  return (
    <>
      <div className="mb-4 flex border w-fit rounded-lg">
        {["All", "Morning", "Afternoon", "Night"].map((tab) => (
          <button
            key={tab}
            onClick={() => setSelectedTab(tab)}
            className={`rounded-lg px-5 py-2 text-sm font-medium transition ${
              selectedTab === tab
                ? "bg-teal-600 text-white"
                : " bg-white text-gray-600 hover:bg-gray-100"
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="overflow-x-auto rounded-lg border bg-white">
        <table className="min-w-full text-xs">
          <thead className="bg-gray-50 text-gray-700">
            <tr>
              <th className="p-3 text-left">Medication</th>
              <th className="p-3 text-left">Dose</th>
              <th className="p-3 text-left">Route</th>
              <th className="p-3 text-left">Frequency</th>
              <th className="p-3 text-left">Dosage</th>
              <th className="p-3 text-left">Taken By</th>
              <th className="p-3 text-left">Status</th>
              <th className="p-3 text-left">Doctor</th>
              <th className="p-3 text-left">Nurse</th>
              <th className="p-3 text-center">Action</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan={10} className="p-6 text-center text-gray-400">
                  Loading medications...
                </td>
              </tr>
            ) : filteredData.length === 0 ? (
              <tr>
                <td colSpan={10} className="p-6 text-center text-gray-400">
                  No medications recorded.
                </td>
              </tr>
            ) : (
              filteredData.map((item) => {
                const status = "Completed";
                return (
                  <tr key={item.id} className="border-t hover:bg-gray-50">
                    <td className="p-3 font-medium">{item.drugName || "--"}</td>
                    <td className="p-3">{item.dose || "--"}</td>
                    <td className="p-3">{item.route || "--"}</td>
                    <td className="p-3">{item.frequency || "--"}</td>
                    <td className="p-3">{item.dosage || "--"}</td>
                    <td className="p-3">{item.takenBy || "--"}</td>

                    <td className="p-3">
                      <span
                        className={`rounded px-2 py-1 text-[10px] ${
                          status === "Completed"
                            ? "bg-blue-100 text-blue-600"
                            : "bg-orange-100 text-orange-600"
                        }`}
                      >
                        {status}
                      </span>
                    </td>

                    <td className="p-3">{"--"}</td>
                    <td className="p-3">{"--"}</td>

                    <td className="p-3">
                      <div className="flex justify-center gap-2">
                        <button className="rounded bg-white border p-1.5 text-blue-600">
                          <FiEdit2 />
                        </button>
                        <button className="rounded bg-white border p-1.5 text-red-500">
                          <FiTrash2 />
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
